"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var SiteUrls_1 = require("@tableau/shared-urls/lib/src/SiteUrls");
var Localize_1 = require("../../../gen-src/Localize");
var ColumnFieldsQueryGql_1 = require("../../queries/ColumnFieldsQueryGql");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.columns && resultData.columns[0] && resultData.columns[0].referencedByFieldsConnection;
}
function getWorkbookId(datasource) {
    return datasource.__typename === 'EmbeddedDatasource' && datasource.workbook && datasource.workbook.vizportalUrlId;
}
function mapResultNode(node) {
    var datasource = node.datasource;
    return {
        id: node.id,
        name: node.name,
        publishedDatasourceVizportalUrlId: datasource && datasource.__typename === 'PublishedDatasource' && datasource.vizportalUrlId || '',
        embeddedDatasourceNodeId: datasource && datasource.__typename === 'EmbeddedDatasource' && datasource.id || '',
        datasourceName: node.datasource && node.datasource.name || '',
        workbookVizportalUrlId: node.datasource && getWorkbookId(node.datasource) || ''
    };
}
function urlForLink(urls, rowData) {
    return rowData.workbookVizportalUrlId ?
        urls.workbookLineageFieldPath(rowData.workbookVizportalUrlId, rowData.id) +
            filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId) :
        urls.datasourceLineageFieldPath(rowData.publishedDatasourceVizportalUrlId, rowData.id);
}
function filterToEmbeddedDatasource(datasourceId) {
    return "?" + SiteUrls_1.CatalogUrlParamKeys.embeddedDataSource + "=" + datasourceId;
}
function nameForLink(rowData) {
    if (rowData.name === null) {
        return null;
    }
    return Localize_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.datasourceName });
}
function ColumnFieldsQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyColumnUsedByFieldsGridMessage();
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: ColumnFieldsQueryGql_1.ColumnFieldsQueryGql, partialQueryVariables: { columnId: props.columnId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: urlForLink, name: nameForLink });
    }));
}
exports.ColumnFieldsQueryGrid = ColumnFieldsQueryGrid;
//# sourceMappingURL=ColumnFieldsQueryGrid.js.map